//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var data = require("./stations-update.geo.json");



//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var newIcon = new L.Icon({
    className: 'newIcon',
    iconSize: [20, 20],
    iconAnchor: [13, 13],
    popupAnchor:  [-3, -14],
    iconUrl: "./assets/new-transit-icon.png"
});

var oldIcon = new L.Icon({
    className: 'oldIcon',
    iconSize: [20, 20],
    iconAnchor: [13, 13],
    popupAnchor:  [-3, -14],
    iconUrl: "./assets/transit-icon.png"
});

var category = {
    "new": "newIcon",
    "old": "oldIcon",
}

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
};

function geojsonMarkerOptions(feature) {
};

var geojson = L.geoJson(data, {    
    pointToLayer: function (feature, latlng) {
        if (feature.properties.category == "new") {
            return L.marker(latlng, {icon: newIcon});
        } else {
            return L.marker(latlng, {icon: oldIcon});
        }
    },
    style: geojsonMarkerOptions,
    onEachFeature: onEachFeature
}).addTo(map);


var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
};

 map.scrollWheelZoom.disable();